import { Grid, Pagination } from '@mui/material';
import * as React from 'react';

export default function TablePageControl({ length, setLength, page, setPage, totalPage, justifyContent = "start" }) {

    const [pageList, setPageList] = React.useState();

    React.useEffect(() => {
        if (totalPage) {
            let tempPageList = [];
            for (let index = 0; index < totalPage; index++) {
                tempPageList.push({ label: index + 1, value: index + 1 })
            }
            setPageList(tempPageList);
        }

    }, [totalPage])

    const handleChangePage = (event, value) => {
        setPage(value);
    };
    return (
        <React.Fragment>
            <Grid container spacing={2} style={{ marginTop: "auto" }}>
                <Grid item sm={12} display={'flex'} alignItems={'center'} justifyContent={justifyContent}>
                    <Pagination
                        count={totalPage || 1}
                        defaultPage={5}
                        siblingCount={0}
                        page={Number(page)}
                        hideNextButton={true}
                        hidePrevButton={true}
                        onChange={handleChangePage}
                        sx={{
                            // Disabled pagination items
                            '& .MuiPaginationItem-root.Mui-selected': {
                                backgroundColor: '#1D1B1B',
                                color: '#FFFFFF',
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
